import { useState } from "react";

const useTabs = function () {
  const [value, setValue] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  return [value, handleChangeTab];
};

export default useTabs;
